import { Fragment } from "react";

const AccessibilityMarkup = ({
    numOptions,
    totalNumOptions,
    accessibilityLabelString,
}) => {
    return (
        <Fragment>
            <span className="a11y" aria-atomic="true" aria-live="polite">
                {"showing " +
                    numOptions +
                    " of " +
                    totalNumOptions +
                    " options"}{" "}
            </span>

            <label htmlFor="option-select-input" className="a11y">
                {accessibilityLabelString}
            </label>
            <span className="a11y" id="option-select-info">
                Use arrow keys to select a option from the suggested list
            </span>
        </Fragment>
    );
};

export default AccessibilityMarkup;
